import script from "./ChatConversationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatConversationHeader.vue?vue&type=script&setup=true&lang=js"

import "./ChatConversationHeader.vue?vue&type=style&index=0&id=4d3855bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3855bc"]])

export default __exports__